export default __webpack_public_path__ + "static/media/Create-documentation.23633620.md";